import { apiIns } from 'src/config/apiClient';
import { DefaultLimit } from 'src/utils/const';

import { createAppAsyncThunk } from '../model';
import { PaymentAction } from './action';

export const getPaymentMethods = createAppAsyncThunk(
  PaymentAction.getPaymentMethods,
  async ({ page = 1, limit = DefaultLimit.Base }: { page?: number; limit?: number }) => {
    try {
      const data = await apiIns.stripe.getCards(page, limit);
      return {
        data: data.results,
        currentPage: page,
        count: data.count,
      };
    } catch {
      return {
        data: [],
        currentPage: 1,
        count: 0,
      };
    }
  },
);
